import Box from '@totallymoney/ui/components/Box'
import styled from 'styled-components'

export const StyledCardTableItemProductDetail = styled(Box)``
